class Doc {
  category = {};

  description = '';

  item = [];

  url= '';

  updateDoc(data) {
    this.category = data.category;
    this.url = data.url;
    this.description = data.description;
    this.image = data.image;
    this.isVersionInfo = data.isVersionInfo;
    this.messageTip = data.messageTip;
    if (data.item) {
      this.item = data.item.map(i => {
        const itemDetail = {};
        itemDetail.image = i.image;
        itemDetail.description = i.description;
        itemDetail.name = i.name;
        if (i.list) {
          itemDetail.list = i.list.map(j => {
            const listDetail = {};
            listDetail.name = j.name;
            listDetail.url = j.url;
            return listDetail;
          });
        }
        return itemDetail;
      });
    }
  }
}
export default Doc;
